/**
 * Audio (docs/spec/04 §5): arcade-board effects and music synthesised with WebAudio, and any
 * music files dropped into `/music`. The game talks to this interface only: it feeds in each
 * tick's events and the continuous state, and nothing here reaches back into the simulation.
 *
 *   const audio = createAudio();                       // safe before any gesture, and without WebAudio
 *   addEventListener('keydown', () => audio.unlock());  // and pointerdown, touchstart
 *   audio.music('title');
 *   // each tick: audio.events(state.events); audio.ambience({ beam, lance });
 */

import { audioContextClass } from './bus';
import { LiveAudio } from './live';
import { SilentAudio } from './silent';
import type { GameAudio } from './types';

export type { Ambience, GameAudio, MusicTrack, UiSound, Volumes } from './types';
export { DEFAULT_VOLUMES } from './types';

/** Never throws: without an AudioContext (Node, a locked-down webview) the game simply runs silent. */
export function createAudio(): GameAudio {
  const Ctor = audioContextClass();
  if (!Ctor) return new SilentAudio();
  try {
    return new LiveAudio(Ctor);
  } catch {
    return new SilentAudio();
  }
}
